/**
@prop --aspect-ratio-mobile: Aspect ratio for the image container on mobile devices (default is 3 / 2).
@prop --aspect-ratio-desktop: Aspect ratio for the image container on desktop devices (default is 3 / 1).
@prop --z-index-fullscreen: Z-index for the zoomed image in fullscreen mode (default is 1000).
@prop --button-bg-color: Color of the zoom button background (default is #fff).
@prop --button-fg-color: Color of the zoom button icon (default is #000).
*/
.ux-iws-nb-image-zoom {
    display: block;
    overflow: hidden;
    position: relative;

    &__container {
        width: 100%;
        aspect-ratio: var(--aspect-ratio-mobile, 3 / 2);
        overflow: hidden;
        position: relative;

        @media (min-width: 1024px) {
            aspect-ratio: var(--aspect-ratio-desktop, 3 / 1);
        }
    }

    &__image-slot {
        position: absolute;
        inset: 0;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__zoom-image {
        position: absolute;
        inset: 0;
        display: none;

        img {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: auto;
            height: auto;
            max-width: 150%;
        }
    }

    &__zoom-button {
        appearance: none;
        cursor: pointer;
        background-color: var(--button-bg-color, #fff);
        color: var(--button-fg-color, #000);
        border: 0 none transparent;
        border-radius: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        position: absolute;
        right: 30px;
        bottom: 30px;
    }

    ux-icon {
        display: none;
        font-size: 20px;
    }

    ux-icon[rel="zoom-in"] {
        display: block;
    }

    &[is-zoomed] {
        ux-icon[rel="zoom-in"] {
            display: none;
        }

        ux-icon[rel="zoom-out"] {
            display: block;
        }

        .ux-iws-nb-image-zoom__zoom-image {
            display: block;
        }
    }
}

/** Fullscreen on small devices */
@media (max-width: 900px) {
    .ux-iws-nb-image-zoom[is-zoomed] {
        .ux-iws-nb-image-zoom__container {
            position: fixed;
            aspect-ratio: unset;
            inset: 0;
            z-index: var(--z-index-fullscreen, 1000);
        }

        .ux-iws-nb-image-zoom__zoom-image img {
            min-height: 100%;
            min-width: 100%;
            max-width: none;
        }
    }
}
